import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import i18n from 'i18next';
import sortBy from 'utils/sortBy';
export var languages = [{
  value: 'en-GB',
  alias: ['en'],
  title: 'English (GB)',
  title_en: 'English (GB)'
}, {
  value: 'en-US',
  alias: ['enUS'],
  title: 'English (US)',
  title_en: 'English (US)'
}, {
  value: 'de-DE',
  alias: ['de'],
  title: 'Deutsch (Du)',
  title_en: 'German (Du)'
}, {
  value: 'de-DE-Sie',
  alias: ['de-Sie'],
  title: 'Deutsch (Sie)',
  title_en: 'German (Sie)'
}, {
  value: 'fr-FR',
  alias: ['fr'],
  title: 'Français',
  title_en: 'French'
}, {
  value: 'es-ES',
  alias: ['es'],
  title: 'Español',
  title_en: 'Spanish'
}, {
  value: 'nl-NL',
  alias: ['nl'],
  title: 'Nederlands',
  title_en: 'Dutch'
}, {
  value: 'no-NO',
  alias: ['nn', 'nb', 'no'],
  title: 'Norsk',
  title_en: 'Norwegian'
}, {
  value: 'pt-PT',
  alias: ['pt'],
  title: 'Português',
  title_en: 'Portuguese'
}, {
  value: 'sv-SE',
  alias: ['se', 'sv'],
  title: 'Svenska',
  title_en: 'Swedish'
}, {
  value: 'zh-CN',
  alias: ['zh'],
  title: '普通话',
  title_en: 'Chinese'
}, {
  value: 'zh-TW',
  alias: ['zh-TW'],
  title: '繁體中文',
  title_en: 'Chinese (Traditional)'
}, {
  value: 'ja-JP',
  alias: ['ja', 'jp'],
  title: '日本語',
  title_en: 'Japanese'
}, {
  value: 'da-DK',
  alias: ['da'],
  title: 'Dansk',
  title_en: 'Danish'
}, {
  value: 'fi-FI',
  alias: ['fi'],
  title: 'Suomi',
  title_en: 'Finnish'
}, {
  value: 'hu-HU',
  alias: ['hu'],
  title: 'Magyar',
  title_en: 'Hungarian'
}, {
  value: 'it-IT',
  alias: ['it'],
  title: 'Italiano',
  title_en: 'Italian'
}, {
  value: 'pl-PL',
  alias: ['pl'],
  title: 'Polski',
  title_en: 'Polish'
}, {
  value: 'ro-RO',
  alias: ['ro'],
  title: 'Română',
  title_en: 'Romanian'
}, {
  value: 'ko-KR',
  alias: ['ko'],
  title: '한국어',
  title_en: 'Korean'
}, {
  value: 'th-TH',
  alias: ['th'],
  title: 'ไทย',
  title_en: 'Thai'
}, {
  value: 'ru-RU',
  alias: ['ru'],
  title: 'Русский',
  title_en: 'Russian'
}];
function getJustLangCode(locale) {
  return locale.split('-')[0];
}
export function formatLanguageCode(code) {
  if (!code) {
    return null;
  }

  // Does the code exist...
  var _iterator = _createForOfIteratorHelper(languages),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      if (item.value === code || item.alias && item.alias.includes(code)) {
        return item.value;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (code.length > 2) {
    return formatLanguageCode(code.substring(0, 2));
  }
  return null;
}
var languagesToMaintainManually = ['de-DE-Sie', 'de-DE', 'zh-CN', 'zh-TW'];
var languagesToIncludeGeography = ['en-GB', 'en-US'];
export function getLanguageName(languageValue) {
  var _i18n$language;
  /*
  Get the substring of the first 5 characters of the language code
  to mitigate issues such as `de-DE-Sie` not being recognised by the Intl API
  */
  var locale = ((_i18n$language = i18n.language) === null || _i18n$language === void 0 ? void 0 : _i18n$language.substring(0, 5)) || 'en-GB';

  /*
   Handle languages for which we maintain the translations manually
   E.g. `German (Sie)` or `Chinese (Traditional)`
   */
  if (languagesToMaintainManually.includes(languageValue)) {
    var _locale = languageValue.replaceAll('-', '_').toLowerCase();
    return i18n.t("language_".concat(_locale));
  }
  try {
    var languageNames = new Intl.DisplayNames([locale], {
      type: 'language'
    });
    /*
    Only show location for select languages, e.g. `English (US)` or `English (GB)`.
    For all other languages, only show the language name.
    */
    var value = languagesToIncludeGeography.includes(languageValue) ? languageValue : getJustLangCode(languageValue);
    return languageNames.of(value);
  } catch (_unused) {
    // All else fails return the language value
    return languageValue;
  }
}
function getLanguageTitle(item) {
  return getLanguageName(item.value);
}
export function getLanguageList() {
  var languageList = sortBy(languages.map(function (item) {
    return {
      title: getLanguageTitle(item),
      value: item.value
    };
  }), function (lang) {
    return lang.title.toLowerCase();
  }) || [];
  return languageList;
}
export function getClosestLanguageCode(detectedLanguage) {
  var _languageCode;
  if (!detectedLanguage) return;
  var languageCode = languages.find(function (_ref) {
    var value = _ref.value;
    return value === detectedLanguage;
  });
  if (!languageCode) {
    var detectedLanguageCode = getJustLangCode(detectedLanguage);
    languageCode = languages.find(function (_ref2) {
      var aliases = _ref2.alias;
      return aliases.some(function (alias) {
        return alias === detectedLanguageCode;
      });
    });
  }
  return (_languageCode = languageCode) === null || _languageCode === void 0 ? void 0 : _languageCode.value;
}